"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrivingLicenceResolveValidation = void 0;
const journey_services_1 = require("@athena-portal/journey-services");
class DrivingLicenceResolveValidation extends journey_services_1.ValidationMethodBase {
    constructor(props) {
        super();
        this.props = props;
        if ((!this.props.licenceID)) {
            throw Error("drivingLicenceResolve validation missing 'licenceID' setting");
        }
    }
    validateInput(input, context) {
        const pageContext = context;
        if (pageContext.engine) {
            const journeyState = pageContext.engine.getJourneyState();
            const isDriverLicenseHandy = this.props.driverIndex ? pageContext.engine.getInteraction().additionalDrivers[this.props.driverIndex].drivingLicenceHandy : true;
            const videoStreamEnabled = journeyState.videoStreamEnabled;
            const frontResolved = journeyState[`${this.props.licenceID}DLFrontResolved`];
            const frontIsUKType = journeyState[`${this.props.licenceID}DLFrontIsUKType`];
            const duplicateFound = isDriverLicenseHandy ? journeyState[`${this.props.licenceID}DuplicateDriverFound`] : false;
            const licenceNotResolved = journeyState[`${this.props.licenceID}LicenceNotResolved`];
            const imageExtensionIsCorrect = journeyState[`${this.props.licenceID}ImageExtensionIsCorrect`];
            if (videoStreamEnabled !== undefined && !videoStreamEnabled) {
                const error = this.getErrorMessage(context, "We can’t access your camera! To prevent you having to enter your " +
                    "driving licence details manually, please give us access to use your camera in settings.");
                return this.invalidResult(error);
            }
            if (imageExtensionIsCorrect !== undefined && !imageExtensionIsCorrect) {
                const error = this.getErrorMessage(context, "Incorrect image extension, you can upload only JPG, PNG, BMP and GIF images.");
                pageContext.engine.setJourneyState({
                    [`${this.props.licenceID}ImageExtensionIsCorrect`]: true
                });
                return this.invalidResult(error);
            }
            else if (frontIsUKType !== undefined && frontIsUKType != null && !frontIsUKType) {
                const error = this.getErrorMessage(context, "We can’t insure drivers with non-UK driving licence. Please upload UK driving licence");
                pageContext.engine.setJourneyState({
                    [`${this.props.licenceID}DLFrontIsUKType`]: true
                });
                return this.invalidResult(error);
            }
            else if (frontResolved !== undefined && frontResolved != null && !frontResolved) {
                const error = this.getErrorMessage(context, "Please upload front of the driving licence.");
                pageContext.engine.setJourneyState({
                    [`${this.props.licenceID}DLFrontResolved`]: true,
                    [`${this.props.licenceID}DLFrontIsUKType`]: true
                });
                return this.invalidResult(error);
            }
            else if (duplicateFound !== undefined && duplicateFound) {
                const error = this.getErrorMessage(context, "This driving licence has been used already. Please upload a different licence.");
                pageContext.engine.setJourneyState({
                    [`${this.props.licenceID}DuplicateDriverFound`]: false
                });
                return this.invalidResult(error);
            }
            else if (licenceNotResolved !== undefined && licenceNotResolved) {
                const error = this.getErrorMessage(context, "Please upload correct driver licence");
                pageContext.engine.setJourneyState({
                    [`${this.props.licenceID}LicenceNotResolved`]: true
                });
                return this.invalidResult(error);
            }
        }
        return this.validResult();
    }
}
exports.DrivingLicenceResolveValidation = DrivingLicenceResolveValidation;
//# sourceMappingURL=DrivingLicenceResolveValidation.js.map